import React from "react";

const greetings = [
  [5, 9, "Coffee in one hand, <em>idea</em> in the other?"],
  [9, 12, "Right on time. <em>Make yourself comfortable.</em>"],
  [12, 15, "Two o'clock and <em>curious</em>. That's half the battle."],
  [15, 17, "Afternoon. The <em>biscuit tin</em> is on the table."],
  [17, 22, "Long day? <em>Pull up a chair.</em>"],
  [22, 24, "Night owls are <em>always welcome</em>."],
  [0, 5, "Night owls are <em>always welcome</em>."],
] as const;

const specialGreetings: Record<string, string> = {
  "4-2": "So long, and thanks for all the <em>thinking</em>.",
  "4-25": "Don't panic. The <em>kettle's on</em>.",
};

const getGreeting = () => {
  const date = new Date();
  const key = `${date.getMonth()}-${date.getDate()}`;

  return (
    specialGreetings[key] ||
    greetings.find(
      ([startHour, endHour]) =>
        date.getHours() >= startHour && date.getHours() < endHour,
    )?.[2] ||
    greetings[1][2]
  );
};

const Title = () => (
  <h1
    className="hero__title"
    dangerouslySetInnerHTML={{ __html: getGreeting() }}
  />
);

export default Title;
